import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiTokenDto } from 'projects/shared/src/lib/models/ApiToken';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { AddApitokenDialogComponent } from './add-apitoken-dialog/add-apitoken-dialog.component';
import { ShowApitokenDialogComponent } from './show-apitoken-dialog/show-apitoken-dialog.component';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AgGridApiTokensSettings } from './AgGridApiTokensSettings';
import { IDatasource, GridApi, GridOptions, IGetRowsParams } from 'ag-grid-community';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { ApitokensButtonRendererComponent } from './apitokens-button-renderer/apitokens-button-renderer.component';

@Component({
  selector: 'manage-apitokens',
  templateUrl: './manage-apitokens.component.html',
  styleUrls: ['./manage-apitokens.component.scss']
})
export class ManageApitokensComponent implements OnInit {

  rowData: ApiTokenDto[] = [];
  //userData: UserDto[] = [];

  //allProfiles: UserProfile[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  frameworkComponents: any;
  filter!: GenericFilter;
  aggridSettings!:AgGridApiTokensSettings;
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
  isLoadingResults = true;
  isRateLimitReached = false;
  isAddPossible = true;
  noUser = false;
  count = 0;

  //_rowData: ApiTokenDto[] = [];
  _userRoles:string[] = [];
  _tenantName!:string;
  _apiTokenForALL = false;
  apiToken!: string;
  ownUserId!: string;
  ownUserName!: string;
  ownUserEmail!: string;

  constructor(
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    //private permissionService: PermissionsService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private notificationService: NotificationService
    ) { }


  ngOnInit() {
    var self = this;

    // this._tenantName = localStorage.getItem('current-tenant-name') as string;
    // this._tenantDb = localStorage.getItem('current-tenant-db') as string;
    this._tenantName = this.tenantService.currentTenantName;
    // this._tenantDb = this.tenantService.currentTenantDb;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          //self._userRoles = data.role as Array<string>;
          let userRoles = data.role as Array<string>;
          userRoles.forEach((role: string) =>{
            if (role != "MANAGE_USERS" && role != "CREATE_USER" &&  role != "MANAGE_PROJECTS" && role != "CREATE_PROJECT") self._userRoles.push(role);
          })
          this.ownUserId = data.sub;
          this.ownUserName = data.name;
          this.ownUserEmail = data.email;
        }
      }
    });

    this.tenantService.getToken(this._tenantName).subscribe({
      next: (token) => {
        var tenantRoles = this.tenantService.getTenantRoles(token);
        //console.log("------> manage-apitokens tenantRoles (aus token): ", tenantRoles)
        tenantRoles.forEach((role: string)=> {
          if (role != "" && !this._userRoles.includes(role)) self._userRoles.push(role);
        });
        this._apiTokenForALL = this._userRoles.includes("CREATE_APITOKEN") || this._userRoles.includes("TENANTADMIN");
        //console.log("------> manage-apitokens self.userRoles (aus token): ", self._userRoles)
        //this.work(); // dann funktioniert F5 nicht!
      }
    });
    this.work();
  }

  work() {
    //let profileMap = new Map<string, UserProfileForCreation>();
    // this.isAuthenticated$ = this.oauthService.isLoggedIn;
    // this.isAuthenticated$.subscribe({
    //   next: (isAuthenticated) => {
    //     this.isAuthenticated = isAuthenticated;
    //   }
    // });

    this.filter = new GenericFilter();
    //console.log("-------> user management _userRoles = ", this._userRoles)
    this.aggridSettings = new AgGridApiTokensSettings(this.translate);
    this.frameworkComponents = {buttonRenderer: ApitokensButtonRendererComponent}
    this.gridOptions = this.aggridSettings.agGridApiTokensSettings;

    this.ds = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {

        this.filter.className = 'ApiTokens';
        this.filter.startRow = params.startRow;
        this.filter.endRow = params.endRow;
        this.filter.sortItems = params.sortModel;
        this.filter.clientFilters = params.filterModel;

        this.gridApi.showLoadingOverlay();
        this.isLoadingResults = true;

        if (this._apiTokenForALL) {
          this.tenantService.getAllApiTokens(this.tenantService.currentTenantName, this.filter).subscribe({
            next: (tokens) => {
              if (tokens.length > 0) {
                this.rowData = tokens;
                //console.log("manage-apitokens rowData ", this.rowData)
                this.rowData = this.rowData.slice(params.startRow, params.endRow);
                let lastRow = -1;     
                if (tokens.length <= params.endRow) {
                  lastRow = tokens.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;      
                this.gridApi.hideOverlay();
              }
              else { // no tokens
                this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Api Token vorhanden!")
                let lastRow = -1;
                if (tokens.length <= params.endRow) {
                  lastRow = tokens.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;
                this.gridApi.hideOverlay();  
              }
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              //this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Api Token Liste")
              console.log("------> error: ", error.error);
              this.notificationService.info("", error.error);
          }
          });
          }
        else {
          this.tenantService.getApiTokens(this.tenantService.currentTenantName, this.ownUserId, this.filter).subscribe({
            next: (tokens) => {
              if (tokens.length > 0) {
                this.rowData = tokens;
                //console.log("manage-apitokens rowData ", this.rowData)
                this.rowData = this.rowData.slice(params.startRow, params.endRow);
                let lastRow = -1;     
                if (tokens.length <= params.endRow) {
                  lastRow = tokens.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;      
                this.gridApi.hideOverlay();
              }
              else { // no tokens
                this.notificationService.info(`${this.translate.data["INFO"]}`, "Kein Api Token vorhanden!")
                let lastRow = -1;
                if (tokens.length <= params.endRow) {
                  lastRow = tokens.length;
                }
                params.successCallback(this.rowData, lastRow);
                this.isLoadingResults = false;
                this.isRateLimitReached = false;
                this.gridApi.hideOverlay();  
              }
            },
            error: (error: any) => {
              this.isLoadingResults = false;
              //this.isRateLimitReached = true;
              this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler Api Token Liste")
              console.log("------> error: ", error)
              this.notificationService.info("", error)
          }
          });
        }
      }
    };
  }

  onGridReady(params: any) {
    this.gridApi = params.api;    
    this.gridApi.sizeColumnsToFit();    
    this.gridApi.setDatasource(this.ds)
  }

  addApiToken() {
    this.apiToken = this.generateGUID();
    console.log("-----> Api Token for all? ", this._apiTokenForALL)

    if (this._apiTokenForALL) {
      const dialogRef = this.dialog.open(AddApitokenDialogComponent, { width: '800px', data: this._apiTokenForALL});
      dialogRef.afterClosed().subscribe((result: any) => { 

        //console.log("-----> user-management.addUser(): result = ", result)
        if (result !== undefined) {
          console.log("-------> manage-apitoken result", result)
    

          const showDialogRef = this.dialog.open(ShowApitokenDialogComponent, { height: '300px', width: '500px', data: this.apiToken});
          showDialogRef.afterClosed().subscribe((showDialogResult: any) => { 

            if (showDialogResult) {
              // console.log("creator: ", this.ownUserName)
              // console.log("creator Id: ", this.ownUserId)
              // console.log("user name: ", result.userDto.tokenUser.userName)
              // console.log("user Id: ", result.userDto.userId)
              // console.log("user Email: ", result.userDto.userEmail)
              //in DB schreiben:
              let apiTokenRec = new ApiTokenDto();
              apiTokenRec.id = this.apiToken;
              apiTokenRec.creator_Id = this.ownUserId;
              apiTokenRec.creator_Name = this.ownUserName;
              apiTokenRec.user_Id = result.userDto.userId;
              apiTokenRec.user_Name = result.userDto.tokenUser.userName;
              apiTokenRec.user_Email = result.userDto.userEmail;
              this.tenantService.createApiTokenRecord(this._tenantName, apiTokenRec).subscribe({
                next: (success) => {
                  this.gridApi.refreshInfiniteCache();
                  this.notificationService.success("", "Api Token wurde erstellt");
                },
                error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler beim Erstellen des Tokens")
              });
            } else { //Abbruch
            }
          });
        }
      },
      //error
      );
    } else {
      // const dialogRef = this.dialog.open(ShowApitokenDialogComponent, { height: '300px', width: '500px', data: apiToken, position: { top: '310px', left: '1300px' } });
      const dialogRef = this.dialog.open(ShowApitokenDialogComponent, { height: '300px', width: '500px', data: this.apiToken});
      dialogRef.afterClosed().subscribe((result: any) => { 

        if (result) {
          // console.log("creator: ", this.ownUserName)
          // console.log("creator Id: ", this.ownUserId)
          // console.log("user: ", this.ownUserName)
          // console.log("user Id: ", this.ownUserId)
          // console.log("user Email: ", this.ownUserEmail)

          //in DB schreiben:
          let apiTokenRec = new ApiTokenDto();
          apiTokenRec.id = this.apiToken;
          apiTokenRec.creator_Id = this.ownUserId;
          apiTokenRec.creator_Name = this.ownUserName;
          apiTokenRec.user_Id = this.ownUserId;
          apiTokenRec.user_Name = this.ownUserName;
          apiTokenRec.user_Email = this.ownUserEmail;
          this.tenantService.createApiTokenRecord(this._tenantName, apiTokenRec).subscribe({
            next: (success) => {
              this.gridApi.refreshInfiniteCache();
              this.notificationService.success("", "Api Token wurde erstellt");
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, "Fehler beim Erstellen des Tokens")
          });

        } else { //Abbruch
        }
      });
    }

  }

  generateGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


}
